import BsDropdownTooltip from './index.vue'
export default BsDropdownTooltip